module.exports = __webpack_public_path__ + "img/Fake_Video-7.662ce67c.jpg";